export default __webpack_public_path__ + "static/media/Nunito-Bold.7ddd6722.ttf";